import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectAuth } from '../../../services/auth/selectors'
import { selectUserLanguagePrimary } from '../../../services/user/index'
import { SeedQuestionFeature } from '../../../graphql-types'
import { useDivinationSeedQuestionListQuery } from '../queries.generated'
import { useMidnightRefresh } from './useMidnightRefresh'
import { extractTagMeta, SeedQuestionTagMeta } from './seedQuestionTagUtils'

export interface TarotSeedQuestion {
  id: string
  question: string
  tagMeta: SeedQuestionTagMeta
}

interface UseTarotSeedQuestionsParams {
  skip?: boolean
}

export const useTarotSeedQuestions = ({
  skip = false,
}: UseTarotSeedQuestionsParams) => {
  const auth = useSelector(selectAuth)
  const language = useSelector(selectUserLanguagePrimary)

  const {
    data,
    loading,
    error,
    refetch,
  } = useDivinationSeedQuestionListQuery({
    skip,
    variables: {
      feature: SeedQuestionFeature.Tarot,
      language,
      limit: 6,
    },
    context: {
      jwt: auth.get('jwt'),
    },
    fetchPolicy: 'network-only',
  })

  useMidnightRefresh(refetch, skip)

  const seedQuestions: TarotSeedQuestion[] = useMemo(() => {
    if (!data?.divinationSeedQuestionList?.seedQuestions) return []

    return data.divinationSeedQuestionList.seedQuestions.map((sq) => ({
      id: sq.id,
      question: sq.question,
      tagMeta: extractTagMeta(sq.tags),
    }))
  }, [data])

  return {
    seedQuestions,
    loading,
    error,
    refetch,
  }
}
